// extracted by mini-css-extract-plugin
module.exports = {"embedContainer":"embedded-module--embedContainer--2Os5D","youtubeContainer":"embedded-module--youtubeContainer--3-CtL"};